import { ProductFamily } from '@chegg/commerce-utils';
export var CSPResubscribe = {
  paymentMethodsHeadingText: 'Payment on file',
  subscriptionInfo: {
    header: 'Resubscribe to Chegg Study Pack',
    subHeader: 'Almost there! We just need to confirm your payment.',
    // @ts-ignore
    billingCadence: {
      monthly: '/mo.',
      semiAnnual: '/mo.',
      annual: '/yr.'
    }
  },
  devicePolicy: {
    heading: 'Device policy:',
    policyText: 'You can access and use Chegg Study on up to two (2) different devices that must be registered at My Account > My Devices.'
  },
  cta: {
    cta: 'Resubscribe',
    reviewButtonText: 'Review',
    upgradeButtonText: 'Upgrade',
    secondaryCta: 'Cancel'
  },
  saleBanner: {
    bannerTitle: "Congrats, you're saving up to 50% off with our Early Semester Sale! -  Limited Time only!",
    link: '/promo/early-semester-sale',
    linkText: 'See sale terms and conditions'
  },
  notificationBanner: {
    bannerTitle: "VPN detected - Please turn off any VPN connections, and refresh the page to see accurate pricing for your region.",
    link: '#',
    linkText: 'Refresh the page'
  },
  tax: {
    taxInfo: 'Your payment method will be charged __${price}/mo.__ + applicable tax',
    discountedTaxInfo: 'Your payment method will be charged ~~${basePrice}~~ __${price}__ + applicable tax'
  },
  valueProps: {
    line1: 'Your Chegg Study Pack includes:',
    line2: '',
    itemListCollection: {
      items: [{
        line1: 'Access to Expert Q&A and 24/7 homework help'
      }, {
        line1: 'Unlimited explanations for each step of your math problem'
      }, {
        line1: 'Expert help to check your papers for plagiarism & grammatical errors'
      }]
    },
    productFamily: ProductFamily.BUNDLE
  },
  coupon: {
    buttonText: 'Got coupon?',
    labelText: 'Coupon Code',
    placeholderText: 'Enter coupon code',
    addCouponText: 'Apply',
    removeCouponText: 'Remove',
    termsCtaText: 'Terms apply',
    successText: 'Coupon applied!',
    termsLabelText: 'Coupon terms'
  },
  termsAndConditions: {
    billingHeading: 'Billing Details:',
    contentTitle: 'Chegg Study Pack Terms',
    content: {
      json: {
        data: {},
        content: [{
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'By clicking “Join now,” you will be enrolled in an auto-renewing monthly subscription for Chegg Study Pack. The Chegg Study Pack subscription includes access to Chegg Study, Chegg Math Solver, and Chegg Writing.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: '\n',
            nodeType: 'text'
          }, {
            data: {},
            marks: [{
              type: 'underline'
            }],
            value: 'Auto-Renewal',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: '\nYour Chegg Study Pack subscription will be renewed each month until you cancel. You consent to Chegg automatically charging your payment method on file ${price} each month (+ tax if applicable) until you cancel. ',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [{
              type: 'underline'
            }],
            value: 'How to Cancel',
            nodeType: 'text'
          }, {
            data: {},
            marks: [],
            value: ' ',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: '\nYou can cancel your subscription anytime by visiting "My Account" on Chegg.com, clicking "Cancel," and selecting “I don’t need all of these tools” and completing the steps to cancel. Cancellations take effect at the end of the billing month in which your request to cancel was received. Subscription fees are not refundable. ',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [{
              type: 'underline'
            }],
            value: 'Chegg Study Pack Monthly Subscription Includes Access to:',
            nodeType: 'text'
          }, {
            data: {},
            marks: [],
            value: ' ',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            content: [{
              data: {},
              content: [{
                data: {},
                marks: [],
                value: 'Chegg Study - access to up to five (5) textbook solution titles per month, the ability to post up to twenty (20) questions per month, unlimited viewing of the Q&A archive, and guided video walkthroughs and practice problems. ',
                nodeType: 'text'
              }],
              nodeType: 'paragraph'
            }],
            nodeType: 'list-item'
          }, {
            data: {},
            content: [{
              data: {},
              content: [{
                data: {},
                marks: [],
                value: 'Chegg Math Solver - unlimited solutions to problems suitable for the solver. ',
                nodeType: 'text'
              }],
              nodeType: 'paragraph'
            }],
            nodeType: 'list-item'
          }, {
            data: {},
            content: [{
              data: {},
              content: [{
                data: {},
                marks: [],
                value: 'Chegg Writing – up to 30 Expert Checks per month, unlimited paper uploads for plagiarism checks and grammar cards, and access to all of the available citation styles. ',
                nodeType: 'text'
              }],
              nodeType: 'paragraph'
            }],
            nodeType: 'list-item'
          }],
          nodeType: 'unordered-list'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: 'Unused monthly subscription benefits have no cash value, are not transferrable, and expire at the end of each month. This means that subscription benefits do not roll over to or accumulate for use in subsequent months. ',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [{
              type: 'underline'
            }],
            value: 'Existing Subscribers to One or More Chegg Study Pack Products',
            nodeType: 'text'
          }, {
            data: {},
            marks: [],
            value: ' ',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: '\nIf you are already a subscriber to Chegg Study, Chegg Math Solver, Chegg Writing or EasyBib Plus, when your subscription begins for Chegg Study Pack your existing subscription(s) for the individual product(s) will be cancelled and you will receive a one-time pro-rated refund of your subscription fee for any days remaining in the then-current billing month(s) for the existing subscription(s).\n\nWhen your subscription to Chegg Study Pack begins, you will receive a one-time pro-rated refund of your subscription fee for any days remaining in the then-current billing month(s) for the existing subscription(s).',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: '\n\n',
            nodeType: 'text'
          }, {
            data: {},
            marks: [{
              type: 'underline'
            }],
            value: 'How to Downgrade your Chegg Study Pack Subscription',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }, {
          data: {},
          content: [{
            data: {},
            marks: [],
            value: '\nYou can downgrade your subscription to Chegg Study Pack at any time by visiting "My Account" on Chegg.com, clicking "Cancel," and selecting "I don’t need all of these tools" and completing the steps that follow. This will result in a cancellation of your existing subscription for Chegg Study Pack, and initiation of a new order for the products that you choose to continue using. If your new order for a subscription to a product available as part of Chegg Study Pack begins on the same day that you cancel your subscription to Chegg Study Pack, you will receive a one-time pro-rated refund of your subscription fee for any days remaining in the then-current billing month(s) for your new order. Downgrading from Chegg Study Pack to one Chegg product may result in a change to your subscription month, and therefore your billing cycle, in addition to the amount of your monthly charges.',
            nodeType: 'text'
          }],
          nodeType: 'paragraph'
        }],
        nodeType: 'document'
      }
    },
    link: 'Chegg Study Pack Terms',
    backButtonText: 'Back to checkout',
    tncPromptText: 'By clicking Join Now you are agreeing to our ${cheggStudyPackTerms}, ${cheggTermsOfUse}, ${privacyPolicy} and for Chegg to charge your payment method for ${price} (+ tax if applicable) for your monthly subscription to Chegg Study Pack. Chegg will automatically charge your payment method monthly until you elect to cancel by selecting cancel membership in My Account.',
    tncPromptTextWithCoupon: "By clicking Join Now you are agreeing to our ${cheggStudyPackTerms}, ${cheggTermsOfUse}, ${privacyPolicy} and for Chegg to charge your payment method for ${priceWithDiscount} today. After that, you'll be charged ${price} per month (+ tax if applicable) for your monthly subscription to Chegg Study Pack. Chegg will automatically charge your payment method monthly until you elect to cancel by selecting cancel membership in My Account.",
    cheggTermsOfUseText: 'Chegg Terms of Use',
    cheggTermsOfUseLink: '/termsofuse',
    privacyPolicyText: 'Privacy Policy',
    privacyPolicyLink: '/privacypolicy'
  },
  orderSummary: {
    heading: 'Order summary:',
    subscription: 'Chegg Study Pack subscription:',
    tax: 'Tax:',
    total: 'Order total:',
    totalPlusTax: '${price} + tax'
  },
  errorModal: {
    header: 'Something went wrong.',
    body: 'Our team is working on it.  Please try again later.'
  },
  variantHeader: {
    header: "You're buying a Chegg Study Pack subscription",
    subheader: 'One step away from the homework help you need.'
  },
  planDuration: {
    annual: 'Annual',
    semiAnnual: '6 Months',
    monthly: 'Monthly'
  },
  frequency: {
    annual: 'every 12 months',
    semiAnnual: 'every 6 months',
    monthly: 'monthly'
  },
  billingCycle: {
    annual: '__${price}__ billed yearly',
    semiAnnual: '__${price}__ billed every 6 months',
    monthly: 'Billed monthly'
  },
  billingCycleHeadingText: 'Choose your billing cycle',
  bestValueText: 'Best value!',
  badgeSave: 'Save ${savings} vs monthly'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/constants/ContentfulFallback/CSPResubscribe.js
// module id = 4181
// module chunks = 11